import { render, staticRenderFns } from "./BundleDataComponent.vue?vue&type=template&id=2c8fba26&"
import script from "./BundleDataComponent.vue?vue&type=script&lang=js&"
export * from "./BundleDataComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports